import { render, staticRenderFns } from "./SinGrupos.vue?vue&type=template&id=f953e07e&scoped=true"
var script = {}
import style0 from "./SinGrupos.vue?vue&type=style&index=0&id=f953e07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f953e07e",
  null
  
)

export default component.exports